import { useEffect } from 'react';
import { Wordmark } from '@accounts/ui';

/**
 * `/session/landed`: where a sign-in in the window a page's session opened ends (`?mode=window`).
 *
 * It runs `@beyond-js/ui/session/landed`, which tells the page that opened the window, and every tab of
 * this interface, that the session was renewed; says so in the window in the browser's language; and
 * closes the window. Nothing here is a credential: the page that opened the window confirms with its own
 * read of the session. Rendered before standing is known, so it speaks even while Accounts is slow.
 */
export function Landed() {
	useEffect(() => {
		// Importing it runs it, once per page load
		void import('@beyond-js/ui/session/landed');
	}, []);

	return (
		<div className="mx-auto flex max-w-md flex-col gap-4 px-4 py-16">
			<Wordmark label="Accounts" />
			<p className="text-body text-ink" data-session-said="" />
		</div>
	);
}
